// @flow
import superagent from 'superagent';
import ApiClient from './ApiClient';

const debug = require('debug')('jp:api:gateway');

export default class Api {
  client: any;

  static consents: {
    get: () => Promise<any>,
    deleteAccount: () => Promise<any>,
    create: (Array<any>) => Promise<any>,
    getTerms: () => Promise<any>,
    getPrivacy: () => Promise<any>
  };

  static geo: {
    getLocation: any,
    search: any
  };

  static locationDetails: {
    reviews: any,
    info: any
  };

  constructor(req: any, agent: any) {
    this.client = new ApiClient(req, agent);
  }

  me() {
    debug('me');
    return this.client.get('/v5/me');
  }

  track(data: any) {
    debug('track', data);
    return this.client.post('/v5/users/tracking', {
      data
    });
  }

  longSession(data: any) {
    debug('longSession', data);
    return this.client.post('/v5/users/session', {
      data
    });
  }

  login(params: any, email: string, password: string, recaptchaToken: string) {
    debug('login', { ...params }, email);
    return this.client.post('/v5/auth/login', {
      data: {
        params,
        username: email,
        password,
        'g-recaptcha-response': recaptchaToken
      }
    });
  }

  google(accessToken: string, queryParams: Object) {
    debug('google');
    return this.client.post('/v5/auth/google', {
      data: {
        access_token: accessToken,
        params: queryParams
      }
    });
  }

  facebook(accessToken: string, queryParams: Object) {
    debug('facebook');
    return this.client.post('/v5/auth/facebook', {
      data: {
        accessToken,
        params: queryParams
      }
    });
  }

  resetPassword(username: string) {
    debug('password-reset');
    return this.client.post('/v4/auth/password-reset', {
      data: {
        username
      }
    });
  }

  register(
    params: any,
    email: string,
    name: string,
    password: string,
    recaptchaToken: string
  ) {
    debug('register', { ...params }, email, name, recaptchaToken);
    return this.client.post('/v4/auth/register', {
      data: {
        params,
        email,
        password,
        name,
        authCookie: true,
        'g-recaptcha-response': recaptchaToken
      }
    });
  }

  logout() {
    debug('logout');
    return this.client.get('/v5/logout');
  }

  getDriveUpListings(id: string) {
    debug('getDriveUpListings', id);
    return this.client.get('/v4/listings/driveup', {
      params: {
        'filter[id]': id
      }
    });
  }

  geo = {
    getLocation: (slug: string, locale: string): Promise<*> => {
      debug('geo.getLocation', slug, locale);
      return this.client.get(`/v5/geo/${locale}/${slug}`);
    },

    search: (data: Object): Promise<*> => {
      debug('geo.search', data);
      return this.client.get('/v5/search', {
        params: {
          ...data,
          cluster: 0,
          driveup: 1
        }
      });
    }
  };

  locationDetails = {
    reviews: (id: number): Promise<*> => {
      debug('getReviews', id);
      return this.client.get(`/v4/listings/${id}/reviews`);
    },

    info: (type: string, id: number): Promise<*> => {
      debug('getLocationInfo', type, id);
      if (
        ['justpark', 'enquiry', 'driveup', 'driveup-onstreet'].indexOf(type) !==
        -1
      ) {
        return this.client.get(`/v4/listings/${id}`);
      }
      return this.client.get(`/v4/data/listing/${id}`);
    }
  };

  vehicles = {
    registrationLookup: (registration: string) => {
      debug('vehicles.registrationLookup', registration);
      return this.client.get('/v4/vehicles/registration-lookup', {
        params: {
          registration
        }
      });
    }
  };

  consents = {
    get: () => {
      debug('consents.get');
      return this.client.get('/v5/consents');
    },
    deleteAccount: () => {
      debug('consents.deleteAccount');
      return this.client.post('/v5/consents', {
        data: {
          data: [
            {
              name: 'standard',
              accepted: false,
              version: 1
            }
          ]
        }
      });
    },
    create: (data: any) => {
      debug('consents.create');
      return this.client.post('/v5/consents', {
        data: {
          data
        }
      });
    },
    getTerms: () => {
      debug('consents.terms');
      return this.client.get('/v4/content/terms-and-conditions');
    },
    getPrivacy: () => {
      debug('consents.privacy');
      return this.client.get('/v4/content/privacy-policy');
    }
  };

  seasonTickets = {
    bootstrap: (vendor: string) => {
      debug('seasonTickets.bootstrap', vendor);
      return this.client.get(
        `/v5/season-tickets/vendor/${vendor}?include=prices,season_listings.address,zones`
      );
    },
    checkout: (data: any) => {
      debug('seasonTickets.checkout', data);
      return this.client.post('/v5/season-tickets/checkout', {
        data
      });
    },
    zones: (zoneId: string) => {
      debug('seasonTickets.zones', zoneId);
      return this.client.get(
        `/v5/season-tickets/zone/${zoneId}?include=listings`
      );
    },
    calculatePrice: (priceId: string, quantity: string) => {
      debug('seasonTickets.calculatePrice', { priceId, quantity });
      return this.client.get('/v5/season-tickets/price', {
        params: {
          price_id: priceId,
          quantity
        }
      });
    }
  };
}

export const client = new Api(null, superagent);
